// extracted by mini-css-extract-plugin
module.exports = {"loadingHero":"Loading_loadingHero__2gk2a","spinner":"Loading_spinner__K0HBe","logo":"Loading_logo__235B-"};